<template>
  <div>
   
    <div class="background" id="colorBackground"></div>
     <!-- INJECT BACKGROUND IMAGES -->
    <div
      class="background"
      v-if="activeBackground && activeBackground.type === 'IMAGE'"
    >
      <img
        :src="activeBackground.urls[0]"
        style="position: absolute; top:0; left: 0; height:100%; width: 100%;
        opacity: 1; object-fit:cover;"
      />
    </div>

    <!-- INJECT BACKGROUND VIDEOS -->
    <div
      class="background"
      v-if="activeBackground && activeBackground.type === 'VIDEO'"
    >
      <video
        :src="activeBackground.url"
        style="position: absolute; top:0; left: 0; height:100%; width: 100%;
        object-fit:cover"
        loop
        autoplay
      >
        <source :src="activeBackground.url" type="video/mp4" />
      </video>
    </div>
  </div>
</template>

<script>
// import Component from "../component_location"

export default {
  components: {},

  props: { narrative: { type: Object, default: () => {} } },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {
    activeBackground() {
      return this.$store.state.narratives.activeBackground;
    }
  },

  mounted() {},
};
</script>

<style>
.background {
  z-index:-1;
  position: absolute;
  top:0; 
  left:0; 
  height:100%; 
  width: 100%;
}

</style>
